module.exports = __webpack_public_path__ + "static/u2-b6c843b8a8a73dd0a0fa50a78b065a3f.png";